import './ImageTemplate.scss';
import { IconArrowMedium } from '../icons/svgs';
import ImagePreview from '../preview/ImagePreview';
import NextAction from '../actions/NextAction';
class ImageTemplate {
    structures() {
        return {
            title: {
                type: 'text',
                label: 'Title',
                placeholder: 'Image',
            },
            description: {
                label: 'Description',
                type: 'tinymce',
                placeholder: 'Description max 600 characters',
                rules: {
                    maxChar: 600, // 320 characters
                }
            },
            images: {
                label: 'Add Image',
                type: 'repeater',
                repeaterType: 'tiles',  // use for styling
                maxOption: 5,
                struct: {
                    image: {
                        type: 'image',
                        rules: {
                            allowedFileType: ['.jpg', '.jpeg', '.png', '.gif'],
                            maxFileSize: 2 * 1024 * 1024, // 2MB
                        }
                    },
                }
            },
            // image : {
            //     label: 'Add Image',
            //     type:'image',   // image picker repeater max 5, renderingnya jika lebih dari 1 maka otomatis carousel
            // }
        }
    }

    type() {
        return 'ImageTemplate';
    }

    name() {
        return 'Image';
    }
    iconType() {
        return 'image';
    }
    canRearrange() {
        return true;
    }
    canRenameLabel() {
        return true;
    }
    imageTemplate() {
        return (
            <div>
                <img src={require('../assets/img/template-image-image.jpg')} className='img-fluid' alt='template' />
            </div>
        );
    }
    textHighlight() {
        return (
            <div>
                <span className='font-weight-700 text-dark'>Text, Description, and Image</span>
                <span className='text-muted'> can be a better explanation to have your topic showed.</span>
            </div>
        );
    }
    getDuration() {
        return 120;
    }
    render(data, index, inEditor) {
        return (
            <ImagePreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }

    actions(data, index) {
        return (
            <NextAction label='Next' icon={<IconArrowMedium />} />
        );
    }
}

export default ImageTemplate;
